//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from "weixin-js-sdk";
import common_form from "@/components/commonRegister/common_form";
export default {
  components: {
    common_form
  },
  data() {
    return {
      dataList: [
        {
          list: [
            {
              type: "input",
              title: "凭证备注(选填)：",
              placeholder: "请输入凭证备注",
              value: ""
            }
          ]
        }
      ],
      btnList: ["点击提交，立即成为新客", "返回"],
      isScan: false,
      scanList: [],
      mainColor: "rgb(81,170,56)",
      uploadImg: "",
      isResult: false,
      activityOpenId: "",
      dataInfo: {},
      isShowUpload: false,
      MemberCenterUrl: "",
      IsDirect: false,
      SystemCode: 0
    };
  },
  created() {
    this.getMemberInfo();
    this.activityOpenId = this.$route.query.activityOpenId;
    this.getScan();
  },
  watch: {},
  methods: {
    goCoupon() {
      window.location.href = this.$api.host + "/mMms/Coupon/Index";
    },
    goMemberCenter() {
      if (this.MemberCenterUrl) {
        window.location.href = this.MemberCenterUrl;
      }
    },
    getMemberInfo() {
      this.$http({
        url: this.$api.memberGetMemberInfo,
        method: "post"
      }).then(res => {
        this.dataInfo = res.data;
        if (res.data.state == 1) {
          this.MemberCenterUrl = res.data.data.MemberCenterUrl;
          this.IsDirect = res.data.data.IsDirect;
        }
      });
    },
    getScan() {
      this.$http({
        url:
          this.$api.wx_sdk_config +
          "?url=" +
          window.location.href.split("#")[0] +
          "&activityOpenId=" +
          this.activityOpenId
      }).then(res => {
        // this.dataInfo = res.data.data;
        if (res.data.state == 1) {
          var data = res.data.data;
          var jsonConfig = {
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["scanQRCode"]
          };
          wx.config(jsonConfig);
          wx.error(err => {
            console.log(err);
          });
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ["scanQRCode"],
              success: res => {}
            });
          });
        }
      });
    },
    beforeScan() {
      this.$http({
        url: this.$api.beforeScan,
        method: "post",
        data: {
          activityOpenId: this.activityOpenId
        }
      }).then(res => {
        if (res.data.state == 1) {
          this.isScan = true;
          this.startScan();
        }
      });
    },
    startScan() {
      if (this.isScan) {
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode"],
          success: res => {
            this.$msg.loading("扫码中");
            this.$http({
              url: this.$api.AfterScan,
              method: "post",
              data: { code: res.resultStr }
            }).then(codeRes => {
              this.$msg.hideLoading();
              if (codeRes.data.state == 1) {
                this.$msg.success("扫码成功");
                this.btnList = [
                  "扫描罐底二维码",
                  "上传购物凭证（必填）",
                  "点击提交，立即成为新客"
                ];
                this.scanList.push({
                  code: codeRes.data.data.FormatCode,
                  text: codeRes.data.data.ProductName
                });
              }
              if (codeRes.data.state == -1) {
                this.$msg.alert(codeRes.data.data);
              }
            });
          }
        });
      } else {
        this.beforeScan();
      }
    },
    closePage() {
      WeixinJSBridge.call("closeWindow");
    },
    delScanItem(index) {
      this.$msg.confirm("确定要删除吗", "", () => {
        this.$http({
          url: this.$api.delScan,
          method: "post",
          data: {
            code: this.scanList[index].code
          }
        }).then(res => {
          if (res.data.state == 1) {
            this.scanList.splice(index, 1);
            this.$msg.success("删除成功");
            if (this.scanList.length == 0) {
              this.btnList = ["点击提交，立即成为新客", "返回"];
            }
          }
        });
      });
    },
    clearUploadImg() {
      this.uploadImg = "";
      this.$refs.fileInput.value = null;
    },
    file_change(e) {
      var imgFile = e.target.files[0];
      if (imgFile) {
        this.$msg.loading("上传中");
        var fr = new FileReader();
        fr.readAsDataURL(imgFile);
        fr.onload = () => {
          var base_url = fr.result
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
              .replace("data:image/jpeg;base64,", ""),
            formData = new FormData();
          formData.append("url", base_url);
          this.$http
            .post(this.$api.upload_img, formData, {
              headers: { "Content-Type": "multipart/form-data" }
            })
            .then(res => {
              this.$msg.hideLoading();
              if (res.data.state == 1) {
                this.uploadImg = res.data.data.src;
              }
            })
            .catch(err => {
              this.$refs.fileInput.value = null;
            });
        };
      }
    },
    btnCb(index) {
      if (this.scanList.length == 0) {
        if (index == 0) {
          this.$msg.fail("请扫描罐底二维码");
        }
        if (index == 1) {
          //返回
          this.goMemberCenter();
        }
      } else {
        if (index == 0) {
          //扫码
          this.startScan();
        }
        if (index == 1) {
          //上传
          this.isShowUpload = !this.isShowUpload;
          window.scrollTo(0, document.documentElement.clientHeight);
        }
        if (index == 2) {
          //提交
          if (!this.uploadImg) {
            this.$msg.fail("请上传购物凭证");
            return;
          }
          this.$msg.loading("提交中");
          this.$http({
            url: this.$api.submitScan,
            method: "post",
            data: {
              FirstPurchaseReceiptFiles: this.uploadImg,
              PurchaseReceiptComment: this.dataList[0].list[0].value
            }
          }).then(res => {
            this.$msg.hideLoading();
            if (res.data.state == 1) {
              this.SystemCode = res.data.data.SystemCode;
              this.isResult = true;
            }
          });
        }
      }
    }
  }
};
